import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const campaignRegister = api
  .enhanceEndpoints({
    addTagTypes: ["campaignRegister"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getCampaignRegisterFields: builder.query({
        query: ({ campaignCode }) => ({
          url: `campaign-by-code/${campaignCode}`,
          method: RequestMethod.GET,
        }),
      }),

      createLeadCampaignRegister: builder.mutation({
        query: (data) => ({
          url: `campaigns/store/leads`,
          method: RequestMethod.POST,
          body: data,
        }),
      }),
    }),
  });

export const {
  useCreateLeadCampaignRegisterMutation,
  useGetCampaignRegisterFieldsQuery,
} = campaignRegister;
